import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { playlist } from './../models/playlist.model';
import { user } from '../models/user.model';
import { map } from 'rxjs/operators';

@Injectable()

export class UserService{
   user: user = new user();
  playlists:playlist[] = [];

  constructor(private http: HttpClient){


  }

  loadPlaylists() {
    this.http.get("https://minmusik.se/api/playlist?user_id=" + this.user.id).pipe(map( (data:playlist[]) => {
      this.playlists = data;
    })).subscribe();
  }

  setMediaToPlaylist(media_id:number, playlist_id:number) {
    let obj = {
      user_id: this.user.id,
      media_id: media_id,
      playlist_id: playlist_id
    }
    this.http.post("https://minmusik.se/api/setMedia2Playlist", obj).pipe(map( (data:playlist[]) => {
      this.playlists = data;
    })).subscribe();
  }

  setPlaylistOrder(playlist_id:number, order_str:string) {
    let obj = {
      user_id: this.user.id,
      order_str: order_str,
      playlist_id: playlist_id
    }
    this.http.post("https://minmusik.se/api/setMediaOrder2Playlist", obj).pipe(map( (data:playlist[]) => {
      this.playlists = data;
    })).subscribe();
  }  

  setPlaylistTitle(playlist_id:number, title:string) {
    let obj = {
      user_id: this.user.id,
      title: title,
      id: playlist_id
    }
    this.http.post("https://minmusik.se/api/setPlaylist", obj).pipe(map( (data:playlist[]) => {
      this.playlists = data;
    })).subscribe();
  }  

  removePlaylist(playlist_id:number){
    this.http.get("https://minmusik.se/api/removePlaylist?id=" + playlist_id + "&user_id=" + this.user.id, ).pipe(map( (data:playlist[]) => {
      this.playlists = data;
    })).subscribe();
  }

  setPassword(password:string){

    let obj = {
      password: password
    }

    return this.http.post("https://minmusik.se/api/setPassword?user_id=" + this.user.id, obj ).pipe(map( (data) => {
      return data["status"];
    }));
  }  

  setUser(email:string, firstname: string, lastname:string, password:string, inapp:number){

    let obj = {
      email: email,
      firstname: firstname,
      lastname: lastname,
      password: password,
      inapp: inapp
    }

    return this.http.post("https://minmusik.se/api/setUser", obj ).pipe(map( (data) => {
      return data["status"];
    }));
  }  

  

}



// WEBPACK FOOTER //
// ./src/service/user.service.ts